import React, { Component } from 'react';
import { AuthContext } from "./../../context/auth";
import {ApiBaseUrl} from '../../constants';
import { trackPromise } from 'react-promise-tracker';
import {withSnackbar} from "react-simple-snackbar";

class Reviews extends Component{
    static contextType = AuthContext;
    state = {
        deals: [],
        avg_rating:0
    }

    componentDidMount(){
        window.scrollTo(0, 0)
        trackPromise(
            fetch(ApiBaseUrl+"/consumer/vendor_reviews/"+this.props.match.params.id,
                {
                    method: 'GET',
                    headers:
                        {
                            "Content-Type" : "application/x-www-form-urlencoded",
                            "Authorization": "Bearer "+this.context.token
                         }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        if(!result.success)
                            this.props.openSnackbar(result.message)
                        else
                            this.setState({
                                deals: result.data.deals,
                                avg_rating: result.data.avg_rating
                            });
                    },
                    // Note: it's important to handle errors here
                    // instead of a catch() block so that we don't swallow
                    // exceptions from actual bugs in components.
                    (error) => {
                        this.props.openSnackbar('Oops, something went wrong.')
                    }
                )
        )
    }

    render(){
        return(
            <div className="choose-deals-outer p-l-0 p-r-0">
                <div className="container">
                    {this.state.deals.length ?
                        <React.Fragment>
                    <div className="head">
                        <h4>{this.state.deals[0].category.name}</h4>
                        <span>Average Rating: {this.state.avg_rating}<i className="fa fa-star"></i></span>
                    </div>
                    <div className="row">

                        {this.state.deals.map(deal => {
                            let stars = []
                            for (var i = 0; i < deal.rate; i++)
                                stars.push(<i key={deal._id+'_'+i} className="fa fa-star"></i>)
                            return (<div key={deal._id} className="feedbackform-outer vendor-review-rating">
                                <div className="row">
                                    <div className="col-lg-2 my-1 spacing-all-category">
                                        <div className="category-box-outer p-0">
                                            <div className="category-box-header h-md">
                                                <img src={deal.consumer.image_full} alt="pic"/>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-10 my-1 mx-auto">
                                        <div className="category-box-body">
                                            <div className="deal_rating_sec">
                                                <h4 className="category-box-body-title custom-height">Only $43 per
                                                    person</h4>
                                                <span>{deal.rate_date}</span>
                                            </div>
                                        </div>
                                        <form autoComplete="off" action="">
                                            <div className="allstar-outer">
                                                <h6 className="text-white mr-1 mb-0">Rating -
                                                    <span>{stars}</span>
                                                </h6>
                                            </div>
                                            <div className="ratingrow-outer">
                                                <h6 className="green-color">{deal.consumer.name}</h6>
                                                <p>{deal.feedback}</p>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>)
                        })}
                    </div>
                        </React.Fragment>
                    :
                    <div className="col-12 text-center text-white">
                        No review and ratings available yet!
                    </div>}
                </div>
            </div>
        )
    }
}

export default withSnackbar(Reviews,{
    position: 'top-center',
    style: {
        backgroundColor: '#fff',
        color: '#000',
        textAlign: 'center',
        zIndex:999
    },
    closeStyle: {
        color: '#000',
    },
});